module.exports = __webpack_public_path__ + "img/icon-miscommunication.050d9024.svg";